//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import MarketsList from '~/components/landing/markets_list'
import MobileMarketsList from '~/components/landing/mobile_markets_list'
import ArzyptoApplication from '~/components/landing/arzypto_application'
import ArzyptoInfo from '~/components/landing/arzypto_info'
import MobileArzyptoInfo from '~/components/landing/mobile_arzypto_info'
import global from '~/mixins/global'
import lists from '~/mixins/lists'
// import LandingSignup from '~/components/landing/landing_signup'
import landingSatistics from '~/components/landing/landing_statistics'
import Referral from '~/components/landing/referral'
import TrendCoins from '~/components/landing/trend_coins'
import LastNews from '~/components/landing/last_news'
import CoinTicker from '~/components/landing/coin_ticker'
export default {
  components: {
    ArzyptoApplication,
    ArzyptoInfo,
    MobileArzyptoInfo,
    MarketsList,
    MobileMarketsList,
    landingSatistics,
    // LandingSignup,
    Referral,
    TrendCoins,
    LastNews,
    CoinTicker
  },
  mixins: [global, lists],
  async asyncData ({ store }) {
    await global.methods.getNewAndTrends(store, process.env.FAPI_URL, process.env.ASYNC_BASE_URL_API)
    await store.dispatch('coins/getArzyptoCoins')
    await store.dispatch('coins/getCoins', { limit: 10, offset: 0, baseURL: '' })
  },
  data () {
    return {
      timer: 0,
      showSlider: false,
      showApp: true
    }
  },
  head () {
    return {
      title: this.$t('head.arzyptoHome')
    }
  },
  computed: {
    ...mapGetters({
      isGuest: 'auth/isGuest'
    })
  },
  async created () {
    this.showSlider = true
    await this.$store.dispatch('coins/getCoinPrice', this.$store.getters['coins/coinsState'].selectedCoin)
  },
  methods: {
    close () {
      this.showApp = false
    }
  }
}
